import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import Chip from '@mui/material/Chip';
import Avatar from '@mui/material/Avatar';
import PersonIcon from '@mui/icons-material/Person';
import UserContext from '../contexts/userContext';
var LoggedInUser = function () {
    var user = useContext(UserContext).user;
    return (_jsx(Chip, { avatar: _jsx(Avatar, { children: _jsx(PersonIcon, {}) }), label: (user === null || user === void 0 ? void 0 : user.displayName) || 'Logged in', variant: "outlined", sx: { m: 2 } }));
};
export default LoggedInUser;
